import React from 'react';
import { 
    Form, 
    Input, 
    Button, 
    Flex, 
    Radio, 
    Divider, 
    Switch, 
    Space, 
    Alert,
    Select,
    message,
    Modal,
    List,
    Popconfirm,
    InputNumber,
    DatePicker,
    TimePicker,
    Checkbox,
    Card
} from 'antd';
import dayjs from 'dayjs';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import goback from '../../utils/goback';
import SwitchShop from '../shop/switch-shop';
import SelectGoods from '../goods/select-goods';
import Geo from '../../components/geo';
import getCurrentShop from '../shop/get-current-shop';
import { getCurrentShopId } from '../shop/get-current-shop';

dayjs.locale('zh-cn');

const { confirm } = Modal;

const NewOrder = (props) => {
    const defFromOptions = [
        {label: '线下', value: '线下'},
        {label: '公司电话', value: '公司电话'},
        {label: '抖音团购', value: '抖音' }, 
        {label: '美团团购', value: '美团'},
        {label: '小红书', value: '小红书'},
    ];

    const [currentShopId, setCurrentShopId] = React.useState(null);
    const [currentShop, setCurrentShop] = React.useState(null);
    const [unit, setUnit] = React.useState();
    const [goodsType, setGoodsType] = React.useState();
    const [form] = Form.useForm();
    const shareType = Form.useWatch('shareType', form);
    const [fromOptions, setFromOptions] = React.useState(defFromOptions);
    const amount = Form.useWatch('shouldAmount', form);
    const quantity = Form.useWatch('quantity', form);
    const [proxyShops, setProxyShops] = React.useState([]);
    const [multiSku, setMultiSku] = React.useState(false);
    const [skuTitle, setSkuTitle] = React.useState('');
    const [skus, setSkus] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {

    }, []);

    React.useEffect(() => {
        const fetchCurrentShopId = async () => {
            const id = await getCurrentShopId();
            setFormFields({});
            getProxyShops().then(res => {
                // console.log('proxyShops', res);
                setProxyShops(res.map(item => {
                    return {
                        // ...item,
                        label: item?.partnerShop?.title,
                        value: item?.partnerShop?.shopId
                    }
                }));
            });
        };

        fetchCurrentShopId();
    }, []);

    const setFormFields = (data) => {
        console.log('setFormFields', data);

        form.setFieldsValue({
            shouldAmount: data.shouldAmount || 0,
            quantity: data.quantity || 1,
        });

        if(data.appointmentTime) {
            form.setFieldsValue({
                appointmentDate: dayjs(data.appointmentTime),
                appointmentTime: dayjs(data.appointmentTime),
            });
        }
    }

    const onGoodsChange = async (goods) => {
        console.log('onGoodsChange', goods);
        goods = goods[0];

        setUnit(goods?.unit);
        setGoodsType(goods?.type);

        if(goods?.multiSku) {
            setMultiSku(goods.multiSku);
            setSkuTitle(goods.skuTitle);
            setSkus({name: goods.skuTitle, options: goods.goods_skus});
        }
    }

    const getOrderDetail = async (orderNo) => {
        const response = await fetch(`/api/order-detail-als?orderNo=${orderNo}`);
        const result = await response.json();
        if(result.success) {
            return result.data;
        }
    }

    const getProxyShops =  async () => { 
        if (!currentShopId) return [];
        const response = await fetch(`/api/shop/partner/list?shopId=${currentShopId}`);
        const result = await response.json();

        if(result.success) {
            return (result?.data?.rows || []);
        }

        return [];
    }


    const onFormSubmit = async () => {
        form.validateFields().then(async values => {
            console.log('values', values);
            const goodsId = values.goodsId?.[0]?.goodsId;
            // 预约时间
            let appointmentTime = values.appointmentDate ? dayjs(values.appointmentDate).format('YYYY-MM-DD') : '';

            if(values.appointmentTime) {
                appointmentTime += ' ' + dayjs(values.appointmentTime).format('HH:mm');
            }

            const currentShopId = await getCurrentShopId();
            const data = {
                ...values,
                goodsId,
                appointmentTime,
                province: values.geo?.[0]?.name,
                provinceCode: values.geo?.[0]?.adcode,
                city: values.geo?.[1]?.name,
                cityCode: values.geo?.[1]?.adcode,
                county: values.geo?.[2]?.name,
                countyCode: values.geo?.[2]?.adcode,
                shopId: currentShopId,
                goodsType,
                unit,
            }

            if(multiSku) {
                data.multiSku = multiSku;
                data.skuList = skus?.options;
            }

            delete data.geo;
            delete data.appointmentDate;

            console.log('data', data);
            requestOrderCreate(data);
        }).catch(err => {
            console.log('err', err);
        })
    }

    const requestOrderCreate = async (data) => {
        const url = '/api/order/create';
        setLoading(true);
        message.loading('正在创建订单...');
        
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        if(result.success) {
            message.success('创建成功');
            setTimeout(() => {
                window.location.href = '/order';
            }, 500);
        } else {
            message.error(result.data);
        }
        setLoading(false);
    }

    return (
        <>
            <SwitchShop />
            <div className='main-form'>
                <h2>创建订单</h2>
                <Alert message={`本次订单将在"${currentShop?.title || '当前'}”店铺下创建，右上角可切换店铺`} type="warning" showIcon style={{marginBottom: '10px'}} />
                <Form form={form} disabled={loading}>
                    <Form.Item
                        label="服务项目"
                        name="goodsId"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <SelectGoods onChange={onGoodsChange} includeProxy={true} />
                    </Form.Item>
                    {
                        multiSku && <Form.Item
                            label={skuTitle}
                            name="skuId"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Radio.Group options={skus.options.map(i => ({ ...i, key: i.skuId, label: i.title, value: i.skuId }))} />
                        </Form.Item>
                    }
                    <div style={{display: 'flex'}}>
                        
                        <Form.Item
                            label="手机号码"
                            style={{width: '40%', marginRight: '8px'}}
                            name="phoneNo"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入手机号码',
                                },
                                {
                                    pattern: /^1[3456789]\d{9}$/,
                                    message: '请输入正确的手机号码',
                                }
                            ]}
                        >
                            <Input type='number' />
                        </Form.Item>
                        <Form.Item
                            label="客户名称"
                            name="customerName"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入客户名称',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </div>
                    <Form.Item
                        label="省市区"
                        style={{width: '30%', marginRight: '8px'}}
                        name="geo"
                        rules={[
                            {
                                required: true,
                                message: '请选择省份！',
                            },
                        ]}
                    >
                        <Geo />
                    </Form.Item>

                    <div style={{display: 'flex'}}>

                        <Form.Item
                            label="详细地址"
                            name="address"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入地址！',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </div>
                    
                    <Flex justify="left" align="center" gap={10}>
                        <Form.Item
                            label="总价"
                            name="shouldAmount"
                            style={{ marginRight: '8px', width: '30%'}}
                            rules={[
                                {
                                    required: true,
                                    message: '请输入正确的金额',
                                },
                            ]}
                        >
                            <InputNumber type='number' min={0} />
                            {/* <span> 抖音/美团预约单请填 0</span> */}
                        </Form.Item>
                        <Form.Item
                            label="数量"
                            name="quantity"
                            style={{ marginRight: '8px', width: '30%'}}
                            rules={[
                                {
                                    required: true,
                                    message: '请输入数量',
                                },
                            ]}
                            // tooltip='抖音/美团预约单请填 0'
                            // help={<span> 抖音/美团预约单请填 0</span>}
                        >
                            <InputNumber type='number' min={1} step={1} />
                            {/* <span> 抖音/美团预约单请填 0</span> */}
                        </Form.Item>
                        <Form.Item
                            label="单价">
                            <span style={{color: 'red'}}>{((amount || 0) / quantity).toFixed(2)}{unit ? '/'+unit: ''}</span>
                        </Form.Item>
                    </Flex>
                    
                    <div style={{display: 'flex'}}>
                        <Form.Item
                            label="预约日期"
                            style={{ marginRight: '8px',}}
                            name="appointmentDate"
                        >
                            <DatePicker
                                locale={zhCN}
                                placeholder='预约日期'
                                style={{ width: '138px' }}
                            />
                        </Form.Item>
                        <Form.Item
                            label="预约时间"
                            style={{ marginRight: '8px',}}
                            name="appointmentTime"
                        >
                            <TimePicker
                                style={{ width: '138px' }}
                                placeholder='预约时间'
                                minuteStep={10}
                                showNow={false}
                                showTime={{
                                    defaultValue: dayjs('08:00', 'HH:mm'),
                                    format: 'HH:mm',
                                }}
                            />
                        </Form.Item>
                    </div>
                    {/* <Form.Item
                        label="分销员"
                        name="guideId"
                        rules={[
                            {
                                required: true,
                                message: '请选择分销员！',
                            },
                        ]}
                    >
                        <Radio.Group options={[{label: '我自己', value: -1 }, {label: '总公司', value: 9}]} />
                    </Form.Item> */}

                    <div style={{display: 'flex'}}>
                        <Form.Item
                            label="订单来源"
                            name="from"
                            rules={[
                                {
                                    required: true,
                                    message: '请选择来源！',
                                },
                            ]}
                        >
                            <Radio.Group 
                                options={fromOptions} 
                            />
                        </Form.Item>

                        {/* <Form.Item
                            label="核销码"
                            name="writeOffCode"
                        >
                            <Input />
                        </Form.Item> */}
                    </div>

                    <Form.Item
                        label="分销/代理"
                        name="shareType"
                        help="个人：登录人获得佣金；店铺：选择后的店铺获得佣金"
                        rules={[{ required: true, message: '请选择分销/代理' }]}
                    >
                        <Radio.Group 
                            options={[{ value: 1, label: '个人' }, { value: 2, label: '总部' }]} 
                        />
                    </Form.Item>

                    {/* {
                        shareType === 2 && <Form.Item
                            label="代理店铺"
                            name='shareShopId'
                            rules={[{ required: true, message: '请选择代理店铺' }]}
                        >
                            <Select placeholder="请选择代理店铺" 
                                options={
                                    (proxyShops || [])
                                        .filter(item => item.shopId !== currentShopId)
                                } 
                            />
                        </Form.Item>
                    } */}
                    
                    <Form.Item
                        label="备注"
                        name="sellerRemark"
                    >
                        <Input.TextArea />
                    </Form.Item>
                    <Divider />
                    <Flex gap={10} justify='center'>
                        <Button onClick={() => goback('/order-list-als')}>取消</Button>
                        <Button type='primary' onClick={onFormSubmit}>提交</Button>
                    </Flex>
                </Form>
            </div>
            
       </>
    );
};

export default NewOrder;